/**
 * Returns onClick + onTouchEnd props for Preact JSX elements.
 * Mirrors the behaviour of addClickAndTouch: touchend gets preventDefault()
 * to suppress the delayed synthetic click iOS fires afterwards.
 */
export function tapProps(handler: (e?: Event) => void) {
    return {
        onClick: (e: Event) => handler(e),
        onTouchEnd: (e: TouchEvent) => { e.preventDefault(); handler(e); },
    };
}
